// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(15, 24, 34, 0.62);
  backdrop-filter: blur(3px);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  z-index: 100;
  animation: modal-fade-in 0.18s ease-out;
}
 
@keyframes modal-fade-in {
  from { opacity: 0; }
  to { opacity: 1; }
}
 
.modal-box {
  position: relative;
  background: #fff;
  border-radius: 16px;
  padding: 50px 32px 32px;
  width: 100%;
  max-width: 460px;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 40px 80px -40px rgba(0, 0, 0, 0.45);
  animation: modal-slide-up 0.22s ease-out;
}
 
@keyframes modal-slide-up {
  from { opacity: 0; transform: translateY(16px); }
  to { opacity: 1; transform: translateY(0); }
}
 
.modal-close {
  position: absolute;
  top: 16px;
  right: 16px;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  border: 0;
  background: var(--soft);
  color: var(--ink);
  display: grid;
  place-items: center;
  cursor: pointer;
}
 
.modal-title {
  font-size: 20px;
  margin-bottom: 6px;
}
 
.modal-subtitle {
  font-size: 13.5px;
  color: var(--body);
  margin-bottom: 20px;
}
 
.modal-form {
  display: flex;
  flex-direction: column;
  gap: 14px;
}
 
.modal-label {
  display: flex;
  flex-direction: column;
  gap: 6px;
  font-size: 12.5px;
  font-weight: 700;
  color: var(--ink);
}
 
.modal-label input,
.modal-label select,
.modal-label textarea {
  font-family: inherit;
  font-size: 14px;
  font-weight: 400;
  padding: 11px 12px;
  border-radius: 9px;
  border: 1px solid var(--line);
  color: var(--ink);
  resize: vertical;
}
 
.modal-label input:focus,
.modal-label select:focus,
.modal-label textarea:focus {
  outline: none;
  border-color: var(--cyan);
}
 
@media (max-width: 480px) {
  .modal-box {
    padding: 50px 20px 24px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/organisms/AlertModal/AlertModal.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,QAAQ;EACR,kCAAkC;EAClC,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,YAAY;EACZ,uCAAuC;AACzC;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,iDAAiD;EACjD,wCAAwC;AAC1C;;AAEA;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC7C;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,SAAS;EACT,uBAAuB;EACvB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;;;EAGE,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,6BAA6B;EAC7B,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;;;EAGE,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE;IACE,uBAAuB;EACzB;AACF","sourcesContent":[".modal-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(15, 24, 34, 0.62);\n  backdrop-filter: blur(3px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 24px;\n  z-index: 100;\n  animation: modal-fade-in 0.18s ease-out;\n}\n \n@keyframes modal-fade-in {\n  from { opacity: 0; }\n  to { opacity: 1; }\n}\n \n.modal-box {\n  position: relative;\n  background: #fff;\n  border-radius: 16px;\n  padding: 50px 32px 32px;\n  width: 100%;\n  max-width: 460px;\n  max-height: 90vh;\n  overflow-y: auto;\n  box-shadow: 0 40px 80px -40px rgba(0, 0, 0, 0.45);\n  animation: modal-slide-up 0.22s ease-out;\n}\n \n@keyframes modal-slide-up {\n  from { opacity: 0; transform: translateY(16px); }\n  to { opacity: 1; transform: translateY(0); }\n}\n \n.modal-close {\n  position: absolute;\n  top: 16px;\n  right: 16px;\n  width: 30px;\n  height: 30px;\n  border-radius: 50%;\n  border: 0;\n  background: var(--soft);\n  color: var(--ink);\n  display: grid;\n  place-items: center;\n  cursor: pointer;\n}\n \n.modal-title {\n  font-size: 20px;\n  margin-bottom: 6px;\n}\n \n.modal-subtitle {\n  font-size: 13.5px;\n  color: var(--body);\n  margin-bottom: 20px;\n}\n \n.modal-form {\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n}\n \n.modal-label {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  font-size: 12.5px;\n  font-weight: 700;\n  color: var(--ink);\n}\n \n.modal-label input,\n.modal-label select,\n.modal-label textarea {\n  font-family: inherit;\n  font-size: 14px;\n  font-weight: 400;\n  padding: 11px 12px;\n  border-radius: 9px;\n  border: 1px solid var(--line);\n  color: var(--ink);\n  resize: vertical;\n}\n \n.modal-label input:focus,\n.modal-label select:focus,\n.modal-label textarea:focus {\n  outline: none;\n  border-color: var(--cyan);\n}\n \n@media (max-width: 480px) {\n  .modal-box {\n    padding: 50px 20px 24px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
